module.exports = __webpack_public_path__ + "static/media/statua.3cfe0d18.jpg";